import { render, staticRenderFns } from "./ChecklistFindingFooter.vue?vue&type=template&id=62947918"
import script from "./ChecklistFindingFooter.vue?vue&type=script&lang=js"
export * from "./ChecklistFindingFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports